import { indigo } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { normalize, setupPage } from 'csstips';
import { Provider } from 'jotai';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import 'url-search-params-polyfill';
import { App } from './components/App';
import { ErrorBoundary } from './components/ErrorBoundary';

function Main() {
  const theme = createTheme({
    palette: {
      primary: indigo
    }
  });

  return (
    <ErrorBoundary>
      <Provider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  );
}

setupPage('#app');
normalize();

const app = document.querySelector('#app');
if (!app) {
  throw new Error('#app is not found');
}

createRoot(app).render(<Main />);
